import { useTranslation } from 'react-i18next';
import {
  Button,
  Col,
  Dropdown,
  MenuProps,
  Modal,
  Row,
  Space,
  Typography,
} from "antd";
import { useNavigate } from "react-router-dom";
import useKeyword from "../../../../../../../hooks/useKeyword";
import { useAddLesson } from "../../../../../../../stores/stores";
import { ExclamationCircleOutlined } from "@ant-design/icons";

type FilterTableProps = {
  selectedRowKeys: any;
  handleDeleteManyQuiz: () => void;
  handleSaveVersionMultipleQuiz: () => void;
  setIsOpenListQuestionBankModal: (value: boolean) => void;
};

const FilterTable = ({
  selectedRowKeys,
  handleDeleteManyQuiz,
  handleSaveVersionMultipleQuiz,
  setIsOpenListQuestionBankModal,
}: FilterTableProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const name = useKeyword("name");
  const params = new URLSearchParams(location.search);
  const permission = params.get("permission");
  const { setQuestion } = useAddLesson();

  const items: MenuProps["items"] = [
    {
      key: "1",
      label: t("Lưu phiên bản", "Lưu phiên bản"),
      disabled: !(selectedRowKeys.length > 0),
      onClick: () =>
        Modal.confirm({
          title: `Lưu phiên bản`,
          content: (
            <span>
              {t("Bạn có chắc chắn muốn lưu phiên bản các câu hỏi đã được chọn?", "Bạn có chắc chắn muốn lưu phiên bản các câu hỏi đã được chọn?")}
              <br />
              <i style={{ color: "#676767" }}>
                {" "}
                Chỉ bản nháp được cập nhật phiên bản, các câu hỏi đã có phiên
                bản sẽ được giữ nguyên
              </i>
            </span>
          ),
          onOk: () => handleSaveVersionMultipleQuiz(),
          centered: true,
          okText: t("Xác nhận", "Xác nhận"),
          cancelText: t("Huỷ", "Huỷ"),
          footer: (_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          ),
        }),
    },
    {
      label: t("Di chuyển", "Di chuyển"),
      key: "2",
      disabled: !(selectedRowKeys.length > 0),
      onClick: () => setIsOpenListQuestionBankModal(true),
    },
    {
      key: "3",
      label: t("Xóa", "Xóa"),
      disabled: !(selectedRowKeys.length > 0),
      danger: true,
      onClick: () =>
        Modal.confirm({
          title: `Xóa câu hỏi`,
          content: `Câu hỏi bị xóa sẽ không thể khôi phục. Bạn có chắc chắn muốn xóa?`,
          onOk: () => handleDeleteManyQuiz(),
          centered: true,
          okText: t("Xác nhận", "Xác nhận"),
          cancelText: t("Huỷ", "Huỷ"),
          footer: (_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          ),
        }),
    },
  ];

  return (
    <div className="heading-extra">
      <Row gutter={8} wrap={false}>
        <Col span={24}>
          <div className="heading-resigter flex">
            {selectedRowKeys.length > 0 ? (
              <>
                <Dropdown
                  className="mr-2"
                  menu={{ items }}
                  placement="bottom"
                  trigger={["click"]}
                  arrow={{ pointAtCenter: true }}
                >
                  <a onClick={(e) => e.preventDefault()}>
                    <Space>
                      <Button>{t("Tuỳ chọn", "Tuỳ chọn")}</Button>
                    </Space>
                  </a>
                </Dropdown>
              </>
            ) : null}
            {permission !== "view" ? (
              <Button
                onClick={() => {
                  navigate(`${location.pathname}/add-questions?name=${name}`);
                  setQuestion({});
                }}
                className="btn btn-primary"
              >
                <Typography.Text>{t("Thêm câu hỏi", "Thêm câu hỏi")}</Typography.Text>
              </Button>
            ) : null}
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default FilterTable;
